/* eslint-disable @next/next/no-img-element */
"use client";

import { c as _c } from "react/compiler-runtime";
import Link from "next/link";
import { useRouter } from "next/navigation";
import { ArrowLongRightIcon } from "@heroicons/react/24/outline";
import { StarIcon } from "@heroicons/react/24/solid";
import FacebookIllustration from "public/assets/heroIllustrations/facebookIllustration.svg";
import AmazonIllustration from "public/assets/heroIllustrations/amazonIllustration.svg";
import AirBnbIllustration from "public/assets/heroIllustrations/airbnbIllustration.svg";
import GoogleIllustration from "public/assets/heroIllustrations/googleIllustration.svg";
import NewCircles from "public/assets/heroIllustrations/newCircles.svg";
import FreeText from "public/assets/heroIllustrations/freeText.svg";
import GetResumeScoreIcon from "public/icons/getResumeScore.svg";
import { cx } from "lib/cx";
import usersImage from "public/assets/heroIllustrations/usersImage.webp";
import atsImage from "public/assets/heroIllustrations/atsImage.webp";
import testimonialImage from "public/assets/heroIllustrations/testimonialImage.webp";
import Image from "next/image";
import { useEffect, useState } from "react";
export const Hero = () => {
  const $ = _c(20);
  useRouter();
  const [, setAccessToken] = useState(null);
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = () => {
      const token = localStorage.getItem("access-token");
      setAccessToken(token);
    };
    t1 = [];
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  useEffect(t0, t1);
  let t2;
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <span className="text-reveal line-1"><span className="text-[#52A1FF]">Enhance</span> Your Existing Resume</span>;
    t3 = <br />;
    $[2] = t2;
    $[3] = t3;
  } else {
    t2 = $[2];
    t3 = $[3];
  }
  let t4;
  let t5;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <span className="text-reveal line-2">Or <span className="text-[#52A1FF]">Generate</span> New Resume</span>;
    t5 = <br />;
    $[4] = t4;
    $[5] = t5;
  } else {
    t4 = $[4];
    t5 = $[5];
  }
  let t6;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <h1 className="hero-h1 font-medium leading-[2.35rem] tracking-tight">{t2}{t3}{t4}{t5}<span className="text-reveal line-3 flex items-center">For{" "}<FreeText className="inline-block h-[27px] w-[38px] lg:h-[36px] lg:w-[51px] xl:h-[45px] xl:w-[64px] 2xl:h-[53px] 2xl:w-[76px]" /></span></h1>;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <h2 className="hero-p font-light"><span className="text-reveal line-1">Professional resume with no hassle.</span><br /><span className="text-reveal line-2">A straight-forward, no-fluff resume builder.</span><br /><span className="text-reveal line-2">No credit card required.</span></h2>;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  let t8;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <Link href="/resume-builder" className="btn-gradient rounded-[40px] px-4 py-1 font-poppins lg:py-2 xl:px-8">Generate Now <ArrowLongRightIcon className="h-6 w-6" /></Link>;
    $[8] = t8;
  } else {
    t8 = $[8];
  }
  let t9;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <div className="fade-in-navbar flex gap-7 text-xs lg:text-sm xl:text-base">{t8}<Link href="/upload-resume" className="flex items-center gap-2 rounded-[40px] px-4 py-1 font-poppins shadow-lg lg:py-2 xl:px-8">Get Resume Score <GetResumeScoreIcon className="h-6 w-6" /></Link></div>;
    $[9] = t9;
  } else {
    t9 = $[9];
  }
  let t10;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <FacebookIllustration className={cx("fade-in-left-hero del-1", "h-auto md:w-[57px] lg:w-[63px]")} />;
    $[10] = t10;
  } else {
    t10 = $[10];
  }
  let t11;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <AmazonIllustration className={cx("fade-in-left-hero del-2 -ml-5", "h-auto md:w-[57px] lg:w-[63px]")} />;
    $[11] = t11;
  } else {
    t11 = $[11];
  }
  let t12;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <AirBnbIllustration className={cx("fade-in-left-hero del-3 -ml-3", "h-auto md:w-[57px] lg:w-[63px]")} />;
    $[12] = t12;
  } else {
    t12 = $[12];
  }
  let t13;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = <GoogleIllustration className={cx("fade-in-left-hero del-4 -ml-4", "h-auto md:w-[57px] lg:w-[63px]")} />;
    $[13] = t13;
  } else {
    t13 = $[13];
  }
  let t14;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = <div className="flex items-center">{t10}{t11}{t12}{t13}<img src="/assets/heroIllustrations/netflixIllustration.svg" alt="" className={cx("fade-in-left-hero del-5 -ml-4", "h-auto md:w-[57px] lg:w-[63px]")} /></div>;
    $[14] = t14;
  } else {
    t14 = $[14];
  }
  let t15;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = <div className="flex w-fit flex-col pt-12 text-[#3A3A3A] md:gap-4 lg:gap-6 xl:gap-9">{t6}{t7}{t9}{t14}<div className="fade-in-navbar text-[#3C3C3C]"><div className="flex gap-1"><StarIcon className="h-5 w-5 text-[#FFC700]" /><StarIcon className="h-5 w-5 text-[#FFC700]" /><StarIcon className="h-5 w-5 text-[#FFC700]" /><StarIcon className="h-5 w-5 text-[#FFC700]" /><div className="font-medium">4.5</div></div><div className="text-xs">Rated by FAANG employees</div></div></div>;
    $[15] = t15;
  } else {
    t15 = $[15];
  }
  let t16;
  let t17;
  let t18;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = <img src="/assets/heroIllustrations/gradientIllustration.svg" alt="" className="absolute 2xl:-right-11" />;
    t17 = <img src="/assets/heroIllustrations/heroBgPattern.svg" alt="" className="absolute right-2" />;
    t18 = <NewCircles className="rotating-circle absolute right-3 top-2 h-auto w-[490px] xl:w-[583px]" />;
    $[16] = t16;
    $[17] = t17;
    $[18] = t18;
  } else {
    t16 = $[16];
    t17 = $[17];
    t18 = $[18];
  }
  let t19;
  if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
    t19 = <section className="hidden overflow-hidden bg-[#F9F9F9] px-8 font-montserrat lg:block lg:h-[calc(100vh-80px)]"><div className="relative">{t15}<div className="absolute right-0 top-0 h-full w-1/2">{t16}{t17}{t18}<img src="/assets/heroIllustrations/heroResumeIllustration.svg" alt="" className={cx("fade-in-top-hero absolute right-16 top-6", "h-[288px] w-[200px] md:h-[360px] md:w-[250px] lg:h-[432px] lg:w-[300px] xl:h-[513px] xl:w-[355px] 2xl:h-[576px] 2xl:w-[400px]")} /><div className={cx("fade-in-diagonal-left absolute right-32 top-16", "md:h-[107px] md:w-[320px] lg:h-[120px] lg:w-[360px] xl:h-[147px] xl:w-[442px] 2xl:h-[167px] 2xl:w-[500px]")}><Image src={usersImage} alt="heroImg" fill={true} loading="eager" sizes="(min-width:1280px) 33vw, (min-width:768px) 40vw, 60vw" quality={85} /></div><div className={cx("fade-in-diagonal-right absolute right-0 top-52", "h-[190px] w-[150px] md:h-[254px] md:w-[200px] lg:h-[305px] lg:w-[240px] xl:h-[363px] xl:w-[286px] 2xl:h-[406px] 2xl:w-[320px]")}><Image src={atsImage} alt="heroImg" fill={true} loading="lazy" sizes="(min-width:1280px) 18vw, (min-width:768px) 22vw, 30vw" quality={85} /></div><div className={cx("fade-in-diagonal-left absolute right-52 top-44", "h-[190px] w-[240px] md:h-[270px] md:w-[340px] lg:h-[317px] lg:w-[400px] xl:h-[384px] xl:w-[484px] 2xl:h-[444px] 2xl:w-[560px]")}><Image src={testimonialImage} alt="heroImg" fill={true} loading="lazy" sizes="(min-width:1280px) 40vw, (min-width:768px) 45vw, 70vw" quality={85} /></div></div></div></section>;
    $[19] = t19;
  } else {
    t19 = $[19];
  }
  return t19;
};